var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitStatusIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_2979)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.00009C5.13401 2.00009 2 5.1341 2 9.00009C2 12.8661 5.13401 16.0001 9 16.0001C12.866 16.0001 16 12.8661 16 9.00009C16 5.1341 12.866 2.00009 9 2.00009ZM0 9.00009C0 4.02953 4.02944 9.15527e-05 9 9.15527e-05C13.9706 9.15527e-05 18 4.02953 18 9.00009C18 13.9707 13.9706 18.0001 9 18.0001C4.02944 18.0001 0 13.9707 0 9.00009Z",
    fill: "#FFCF24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.00009C11 10.1047 10.1046 11.0001 9 11.0001C7.89543 11.0001 7 10.1047 7 9.00009C7 7.89552 7.89543 7.00009 9 7.00009C10.1046 7.00009 11 7.89552 11 9.00009Z",
    fill: "#FFCF24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_2979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitStatusIn);
export default __webpack_public_path__ + "static/media/visitStatusIn.502b894d009368b8906dcf27fb5f1bb3.svg";
export { ForwardRef as ReactComponent };